/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { LoadResult } from '../models/load-result';
import { PictogrammeDto } from '../models/pictogramme-dto';


/**
 * Fonctions de gestion des pictogrammes
 */
@Injectable({
  providedIn: 'root',
})
export class PictogrammesService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation pictogrammesGetList
   */
  static readonly PictogrammesGetListPath = '/api/pictogrammes/list';

  /**
   * Renvoie la liste des pictogrammes.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pictogrammesGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  pictogrammesGetList$Response(params?: {
  }): Observable<StrictHttpResponse<Array<PictogrammeDto>>> {

    const rb = new RequestBuilder(this.rootUrl, PictogrammesService.PictogrammesGetListPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<PictogrammeDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des pictogrammes.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `pictogrammesGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  pictogrammesGetList(params?: {
  }): Observable<Array<PictogrammeDto>> {

    return this.pictogrammesGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<PictogrammeDto>>) => r.body as Array<PictogrammeDto>)
    );
  }

  /**
   * Path part for operation pictogrammesLoadList
   */
  static readonly PictogrammesLoadListPath = '/api/pictogrammes/load-list';

  /**
   * Renvoie la liste des pictogrammes (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pictogrammesLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  pictogrammesLoadList$Response(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, PictogrammesService.PictogrammesLoadListPath, 'post');
    if (params) {
      rb.query('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des pictogrammes (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `pictogrammesLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  pictogrammesLoadList(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.pictogrammesLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation pictogrammesGet
   */
  static readonly PictogrammesGetPath = '/api/pictogrammes/{id}';

  /**
   * Renvoie le pictogramme spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pictogrammesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  pictogrammesGet$Response(params: {

    /**
     * Identifiant du pictogramme
     */
    id: number;
  }): Observable<StrictHttpResponse<PictogrammeDto>> {

    const rb = new RequestBuilder(this.rootUrl, PictogrammesService.PictogrammesGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PictogrammeDto>;
      })
    );
  }

  /**
   * Renvoie le pictogramme spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `pictogrammesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  pictogrammesGet(params: {

    /**
     * Identifiant du pictogramme
     */
    id: number;
  }): Observable<PictogrammeDto> {

    return this.pictogrammesGet$Response(params).pipe(
      map((r: StrictHttpResponse<PictogrammeDto>) => r.body as PictogrammeDto)
    );
  }

  /**
   * Path part for operation pictogrammesPut
   */
  static readonly PictogrammesPutPath = '/api/pictogrammes/{id}';

  /**
   * Met à jour le pictogramme spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pictogrammesPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  pictogrammesPut$Response(params: {

    /**
     * Identifiant du pictogramme à mettre à jour
     */
    id: number;

    /**
     * Pictogramme
     */
    body: PictogrammeDto
  }): Observable<StrictHttpResponse<PictogrammeDto>> {

    const rb = new RequestBuilder(this.rootUrl, PictogrammesService.PictogrammesPutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PictogrammeDto>;
      })
    );
  }

  /**
   * Met à jour le pictogramme spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `pictogrammesPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  pictogrammesPut(params: {

    /**
     * Identifiant du pictogramme à mettre à jour
     */
    id: number;

    /**
     * Pictogramme
     */
    body: PictogrammeDto
  }): Observable<PictogrammeDto> {

    return this.pictogrammesPut$Response(params).pipe(
      map((r: StrictHttpResponse<PictogrammeDto>) => r.body as PictogrammeDto)
    );
  }

  /**
   * Path part for operation pictogrammesDelete
   */
  static readonly PictogrammesDeletePath = '/api/pictogrammes/{id}';

  /**
   * Supprime le pictogramme spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pictogrammesDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  pictogrammesDelete$Response(params: {

    /**
     * Identifiant du pictogramme à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, PictogrammesService.PictogrammesDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Supprime le pictogramme spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `pictogrammesDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  pictogrammesDelete(params: {

    /**
     * Identifiant du pictogramme à supprimer
     */
    id: number;
  }): Observable<number> {

    return this.pictogrammesDelete$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation pictogrammesPost
   */
  static readonly PictogrammesPostPath = '/api/pictogrammes';

  /**
   * Crée le pictogramme.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pictogrammesPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  pictogrammesPost$Response(params: {

    /**
     * Pictogramme
     */
    body: PictogrammeDto
  }): Observable<StrictHttpResponse<PictogrammeDto>> {

    const rb = new RequestBuilder(this.rootUrl, PictogrammesService.PictogrammesPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PictogrammeDto>;
      })
    );
  }

  /**
   * Crée le pictogramme.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `pictogrammesPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  pictogrammesPost(params: {

    /**
     * Pictogramme
     */
    body: PictogrammeDto
  }): Observable<PictogrammeDto> {

    return this.pictogrammesPost$Response(params).pipe(
      map((r: StrictHttpResponse<PictogrammeDto>) => r.body as PictogrammeDto)
    );
  }

  /**
   * Path part for operation pictogrammesUploadPictogramme
   */
  static readonly PictogrammesUploadPictogrammePath = '/api/pictogrammes/upload';

  /**
   * Crée un pictogramme.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pictogrammesUploadPictogramme()` instead.
   *
   * This method doesn't expect any request body.
   */
  pictogrammesUploadPictogramme$Response(params?: {
  }): Observable<StrictHttpResponse<PictogrammeDto>> {

    const rb = new RequestBuilder(this.rootUrl, PictogrammesService.PictogrammesUploadPictogrammePath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PictogrammeDto>;
      })
    );
  }

  /**
   * Crée un pictogramme.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `pictogrammesUploadPictogramme$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  pictogrammesUploadPictogramme(params?: {
  }): Observable<PictogrammeDto> {

    return this.pictogrammesUploadPictogramme$Response(params).pipe(
      map((r: StrictHttpResponse<PictogrammeDto>) => r.body as PictogrammeDto)
    );
  }

}
